import _ from 'lodash';

function trim(text) {
    return _.trim(text);
}

export default {
    trim
};
